import type { RootState } from '../../createStore'

export const selectNotifications = (state: RootState) => state.notifications
